import { useState } from 'react';
import { Button, FormGroup, HFlex, Input, Modal, VGrid, useToasts } from 'tombac';
import { useUserDetails } from "../UserDetailsProvider";
import { useApigeeDeveloperMutation } from "../api/userManagementApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditUserApigeeDeveloperModal = _ref => {
  let {
    isOpen,
    onRequestClose,
    mail
  } = _ref;
  const [value, setValue] = useState(mail);
  const user = useUserDetails();
  const {
    addToast
  } = useToasts();
  const {
    isLoading,
    mutate: updateApigeeDeveloper
  } = useApigeeDeveloperMutation();
  const handleSave = async () => {
    updateApigeeDeveloper({
      mail: value,
      username: user.email
    }, {
      onError: async error => {
        console.error(error);
        const response = await error.json();
        addToast(response.message ? /*#__PURE__*/_jsx("div", {
          style: {
            overflowWrap: 'anywhere',
            paddingRight: '5px'
          },
          children: response.message
        }) : "Could not update user's developer email.", 'danger');
      },
      onSuccess() {
        addToast("User's developer email has been changed.", 'success');
        onRequestClose();
      }
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "EditUserApigeeDeveloperModal",
    "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
    children: /*#__PURE__*/_jsxs(VGrid, {
      gap: 3,
      $p: "4sp",
      $pb: "3sp",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
      "data-sentry-element": "VGrid",
      children: [/*#__PURE__*/_jsx(FormGroup, {
        $width: "40sp",
        htmlFor: "apigee-email-input",
        label: "Apigee email",
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          id: "apigee-email-input",
          onChange: e => setValue(e.target.value),
          value: value,
          "data-sentry-element": "Input",
          "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
          "data-sentry-element": "Input"
        })
      }), /*#__PURE__*/_jsxs(HFlex, {
        "data-sentry-element": "HFlex",
        "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
        "data-sentry-element": "HFlex",
        children: [/*#__PURE__*/_jsx(Button, {
          $ml: "auto",
          onClick: () => {
            onRequestClose();
            setValue(mail);
          },
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          busy: isLoading,
          $ml: "1sp",
          onClick: handleSave,
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "EditUserApigeeDeveloperModal.tsx",
          "data-sentry-element": "Button",
          children: "Save"
        })]
      })]
    })
  });
};